import React from 'react';
import { Gruser } from '../../types/papi';
import { PapiUser } from '@wix/da-papi-types';

export const GruserContext = React.createContext<{
  gruser: Gruser | undefined;
  gruserOwner: PapiUser | undefined;
}>({ gruser: undefined, gruserOwner: undefined });
GruserContext.displayName = 'GruserContext';

export default GruserContext;
